<template>
  <div v-if="isAllDone">
    <div class="container pt-4 h-screen flex items-center justify-center">
      <div class="row">
        <div class="col-sm-12">
          <div class="font-semibold tx-16 max-w-3xl mx-auto text-center">Таны хүсэлт амжилттай илгээгдлээ.</div>
          <div class="max-w-3xl mx-auto text-center mt-2">
            <el-button @click="goToParent()" type="primary">Эхлэл хуудас руу буцаана уу</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container pt-4" v-else>
      <div class="row">
        <div class="col-sm-12">
          
          <div class="font-semibold tx-16 max-w-3xl mx-auto text-center">ХҮНДЭТГЭХ ШАЛТГААНААР НИЙСЛЭЛД 48 ЦАГААС ДЭЭШ ХУГАЦААНД ЗОРЧСОН ОРОН НУТГИЙН ТЭЭВРИЙН ХЭРЭГСЭЛ 5000 ТӨГРӨГИЙН ХУРААМЖ ТӨЛӨХГҮЙ 
          </div>

          <div class="my-4">Нийслэлийн иргэдийн төлөөлөгчдийн хурлын 2024 оны 02 дугаар сарын 08-ны өдрийн тогтоолоор авто зам ашигласны төлбөрийн хэмжээг шинэчлэн баталсан.Уг тогтоолд нийслэлд бүртгэлгүй орон нутгийн тээврийн хэрэгсэл нийслэлд 48 цаг буюу хоёр өдөр зорчвол 1000 төгрөг төлнө. Харин 48 цагаас дээш хугацаанд зорчвол хоногт 5000 төгрөг төлөхөөр шийдвэрлэсэн байдаг. Нийслэлийн засаг даргын 2025 оны 01 дүгээр сарын 28-ны өдрийн А/94 дүгээр захирамжийн хүрээнд нийслэлд бүртгэлгүй орон нутгийн дугаартай тээврийн хэрэгслийг дараах 4 нөхцөлөөр төлбөрөөс чөлөөлөх журамд өөрчлөлт орсон.
          </div>

          <div class="">2025 оны 02 дугаар сарын 15-ны өдрөөс эхлэн  4 төрлийн мэдээллийн дагуу иргэний хүсэлт, нотлох баримтыг www.ubtraffic.mn сайтаар хүлээн авна.
          </div>

          <div v-show="reqObj.step == 1" class="mt-8 mx-auto max-w-3xl">
            <el-form
              @submit.prevent="onSubmit"
              ref="myform"
              :model="taskModel"
              :rules="reqObj.stepRequestRule"
              label-width="320px"
              class="myfrm"
              :label-position="isMobile ? 'top' : 'right'"
              width="100%"
            >
              <el-form-item
                label="Т/Х улсын дугаар"
                required
                prop="langCode"
              >
                <el-input
                  v-model="taskModel.langCode"
                  style="width: 200px"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="Хүсэлт гаргагчийн овог нэр"
                required
                prop="task"
              >
                <el-input
                  v-model="taskModel.task"
                  style="width: 200px"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="Утасны дугаараа оруулна уу"
                required
                prop="phone"
              >
                <el-input
                  v-model="taskModel.phone"
                  style="width: 200px"
                ></el-input>
              </el-form-item>

              

              <el-form-item
                label="И-мэйл хаяг"
                required
                prop="mobile"
                class="mg-t-15"
              >
                <el-input
                  v-model="taskModel.mobile"
                  style="width: 200px"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="Иргэний хүсэлт"
                style="margin-bottom: 5px"
                required
                prop="defaultAttachmentId"
              >
                <upldr
                  :id="taskModel.defaultAttachmentId"
                  @on-success="fileUploaded($event, 10)"
                ></upldr>
              </el-form-item>
              


              <!-- <el-form-item label="Шалтгаан" required prop="locTypeId"> -->
              <div class="">
              <div class="uppercase font-medium mb-1">Шалтгаан сонгоно уу</div>
              <div @click="taskModel.locTypeId= r.value" v-for="(r, ri) in reqObj.places" :key="ri" 
              class="mb-2 cursor-pointer hover:bg-blue-50" :class="{'bg-blue-50': r.value == taskModel.locTypeId}">
                <div class="border rounded-md p-2 leading-tight flex gap-2 items-center">
                  <div class="w-6 h-6">
                    <svg v-if="r.value == taskModel.locTypeId" 
                      xmlns="http://www.w3.org/2000/svg" 
                      width="24" 
                      height="24" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      stroke-width="2" 
                      stroke-linecap="round" 
                      stroke-linejoin="round">
                      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                      <polyline points="22 4 12 14.01 9 11.01"/>
                    </svg>
                    <svg v-else
                      xmlns="http://www.w3.org/2000/svg" 
                      width="24" 
                      height="24" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      stroke-width="2" 
                      stroke-linecap="round" 
                      stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10"/>
                    </svg>
                  </div>
                  <div>{{ r.label }}</div>
                </div>
              </div>
            </div>
              <!-- </el-form-item> -->
              


              

              <el-form-item v-if="taskModel.locTypeId !==null"
                class="mg-t-15"
                :label="getLbl1()"
                style="margin-bottom: 5px"
                prop="secondAttachmentId"
              >
                <upldr
                  :id="taskModel.secondAttachmentId"
                  @on-success="fileUploaded($event, 11)"
                ></upldr>
              </el-form-item>

              <el-form-item v-if="taskModel.locTypeId ===489972"
                class="mg-t-40"
                label="Тээврийн хэрэгсэлд гэмтэл учирч хөдөлгөөнд оролцоогүй бол гэмтэл учирсан нь үнэн болох тээврийн хэрэгслийн зураг, засварт үйлчилгээ хийлгэсэн бол үйлчилгээний төлбөрийн баримт, бусад"
                style="margin-bottom: 5px"
                prop="thirdAttachmentId"
              >
                <upldr
                  :id="taskModel.thirdAttachmentId"
                  @on-success="fileUploaded($event, 22)"
                ></upldr>
              </el-form-item>

              <el-form-item v-if="taskModel.locTypeId ===489972"
                class="mg-t-80"
                label="тээврийн хэрэгслийг хөдөлгөөнд оролцоогүй маршрутыг Тээврийн цагдаагийн алба болон Замын хөдөлгөөний удирдлагын төв хамтран давхар шалгаж тогтооно."
                style="margin-bottom: 5px"
                prop="fourthAttachmentId"
              >
                <upldr
                  :id="taskModel.fourthAttachmentId"
                  @on-success="fileUploaded($event, 33)"
                ></upldr>
              </el-form-item>


            </el-form>
            <div slot="footer" class="dialog-footer wd-100p text-right mg-t-40">
              <el-button
                @click="
                  resetForm();
                  reqObj.modal = false;
                "
                type="warning"
                >Болих</el-button
              >
              <el-button @click="onSubmit" type="primary">Илгээх</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
// import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
// import 'swiper/css/swiper.css'

import { request } from "@/api/all";
import { mapActions } from "vuex";
import { setToken } from "@/libs/util";
import upldr from "@/views/Index/uploader.vue";
import moment from "moment";

export default {
  components: {
    upldr,
    //     Swiper,
    //   SwiperSlide
  },
  data() {
    return {
      isAllDone: false,
      achaaOptions: [
        {
          value: "Машин, техник",
          label: "Машин, техник",
        },
        {
          value: "Автокран",
          label: "Автокран",
        },
        {
          value: "Тоног төхөөрөмж",
          label: "Тоног төхөөрөмж",
        },
        {
          value: "Бусад",
          label: "Бусад",
        },
      ],
      locTypeIdSelected: [],
      locTypeId1Selected: [],
      isMobile: false,
      imgcur: "",
      imglst: [
        "images/slide1.jpg",
        "images/slide1.jpg",
      ],

      p1: null,
      p2: null,
      p3: null,
      isFocused1: false,
      isFocused2: false,
      options: [
        {
          value: "guide",
          label: "Guide",
        },
      ],
      pdfModal: false,
      taskModel: {
        // task: "",
        // defaultAttachmentId: null,
        // //secondAttachmentId: null,
        // //thirdAttachmentId: null,
        // //fourthAttachmentId: null,
        // //fifthAttachmentId: null,
        // phone: null,
        // mobile: null,
        // d1: null,
      },
      bjMin: 0,
      bjMax: 0,
      vehicleModel: {
        task: "",
        taskEn: "",
        defaultAttachmentId: null,
        secondAttachmentId: null,
        thirdAttachmentId: null,
        fourthAttachmentId: null,
        fifthAttachmentId: null,
        phone: null,
        mobile: null,
        d1: null,
      },
      reqObj: {
        typeObj: {
          modal: false,
          selectedType: null,
          parentRequestObj: {
            id: null,
            task: null,
            defaultAttachmentId: null,
            secondAttachmentId: null,
            i3: null,
            st2: null,

            d1: null,
            d2: null,
            mobile: null,
            locTypeId: null,
            locTypeId1: null,
            fl1: null,
          },
        },
        vehicleFormShow: false,
        step: 1,
        //step: 2,
        requestTaskObj: {},
        vehicles: [],
        invoiceTaskObj: {},
        invoiceModel: {
          invoiceId: 3176483,
        },
        paymentStep: {
          invoiceQpay: {},
          paymentMethodSelected: null,
          paymentOptions: [
            {
              id: 1,
              name: "QPAY",
            },
            // {
            //   id: 2,
            //   name: "Social Pay",
            // },
          ],
        },
        modal: false,
        requestId: 3176479,
        vehicleBoxId: null,
        pdfLink: "",
        places: [],
        placesFlat: [],
        chirguulTypes: [],
        stepRequestRule: {
          task: [
            {
              required: true,
              message: "Хүсэлт гаргагчийн овог нэр бичнэ үү",
              trigger: "blur",
            },
          ],
          langCode: [
            {
              required: true,
              message: "Т/Х улсын дугаар бичнэ үү",
              trigger: "blur",
            },
          ],
          
          phone: [
            {
              required: true,
              message: "Утасны дугаараа оруулна уу",
              trigger: "blur",
            },
          ],
          mobile: [
            {
              required: true,
              message: "И-мэйл хаяг оруулна уу",
              trigger: "blur",
            },
          ],
          defaultAttachmentId: [
            {
              required: true,
              message: "Иргэний хүсэлт оруулна уу",
              trigger: "blur",
            },
          ],
          secondAttachmentId: [
            {
              required: true,
              message: "Файл сонгоно уу",
              trigger: "blur",
            },
          ],
          thirdAttachmentId: [
            {
              required: true,
              message: "Файл сонгоно уу",
              trigger: "blur",
            },
          ],
          fourthAttachmentId: [
            {
              required: true,
              message: "Файл сонгоно уу",
              trigger: "blur",
            },
          ],
        },
      },
      ebarimtObj: {
        modal: false,
        key: 0,
        id: 0,
        type: null,
        regNo: "",
        mode: 0,
        ebarimt: {},
        base64: null,
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.isMobile = window.innerWidth <= 768;
      this.onResize();
      window.addEventListener("resize", this.onResize, { passive: true });

      this.reqObj.typeObj.selectedType = 0;
      this.checkRequestId();
      
      // if (this.reqObj.step == 3) {
      //   this.paymentMethodSelected({ id: 1 });
      // } else if (this.reqObj.step == 4) {
      //   this.createTransitRequestPdf();
      // }
    });
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth <= 768;
    },
    goToParent(){
      window.location.href = 'https://www.ubtraffic.mn/';
    },
    ...mapActions(["handleLoading"]),
    getLbl1() {
      let rv= '';
      if (this.taskModel.locTypeId === 489973) {
        rv = 'Онцгой байдлын үед ажиллах эрх бүхий байгууллагаас гаргасан шийдвэр (журам, тогтоол, захирамж, тушаал, албан бичиг гэх мэт мэдээллийг хавсаргана.)';
      } else if (this.taskModel.locTypeId === 489971) {
        rv = 'нотлох бичиг баримт, тээврийн хэрэгслийн буяны ажлын бичиг, бусад';
      } else if (this.taskModel.locTypeId === 489972) {
        rv = 'зам тээврийн осолд холбогдож тээврийн хэрэгсэлд гэмтэл учирсан бол эрх бүхий байгууллагын тодорхойлолт.';
      } else if (this.taskModel.locTypeId === 489970) {
        rv = 'Үйлчилгээ авсан эмнэлэгийн эмчлэгч эмчийн тамга, тэмдэг, гарын үсэг бүхий эмнэлэгийн бичиг, бусад';
      }
      return rv;
    },
    fileUploaded(e, mode) {
      console.log('e', e, mode);
      if (mode == 10) {
        this.taskModel.defaultAttachmentId = e.uploadedAttachmentId;
      } else if (mode == 11) {
        this.taskModel.secondAttachmentId = e.uploadedAttachmentId;
      } else if (mode == 22) {
        this.taskModel.thirdAttachmentId = e.uploadedAttachmentId;
      } else if (mode == 33) {
        this.taskModel.fourthAttachmentId = e.uploadedAttachmentId;
      }
    },
    resetForm() {
      this.$refs.myform.resetFields();
    },
    onSubmit() {
      if (this.taskModel.locTypeId === null) {
        this.$message.error("Шалтгаан сонгоно уу.");
        alert('Шалтгаан сонгоно уу.');
        return false;
      }

      this.$refs.myform.validate((valid) => {
        if (valid) {
          this.handleLoading({ isLoading: true });
          //this.taskModel.d1 = new Date();
          request({
            api: { method: "POST", url: "Task/PostInherited" },
            data: { model: this.taskModel },
            store: this.$store,
          }).then((res) => {
            this.handleLoading({ isLoading: false });
            if (res != false) {
              this.$message({
                type: "success",
                message: "Таны хүсэлт амжилттай илгээгдлээ.",
              });
              this.resetForm();
              this.isAllDone = true;
            }
          });
        } else {
          return false;
        }
      });
    },
    showPdfModal() {
      this.pdfModal = true;
    },
    checkRequestId() {
      this.showReqModal();
    },
    showReqModal() {
      this.handleLoading({ isLoading: true });
      request({
        api: { method: "POST", url: "user/LoginApi" },
        params: {
          user: "ztruser",
          password: "ztruser#",
          key: "r_M_7W13zkq8gKc1sXlL_A",
        },
        store: this.$store,
      }).then((resa) => {
        // console.log('resa', resa);
        this.handleLoading({ isLoading: false });
        if (resa !== false) {
          //console.log("-2");
          setToken(resa.token);
          this.handleLoading({ isLoading: true });
          request({
            api: { method: "GET", url: "Type/GetAsyncTreeDataNA" },
            params: {
              key: "ztrReason",
            },
            store: this.$store,
          }).then((res) => {
            this.handleLoading({ isLoading: false });
            this.reqObj.places = res.data.types;
          });


          this.handleLoading({ isLoading: true });
          request({
            api: { method: "GET", url: "Task/GetInherited" },
            params: {
              id: 0,
              objectTypeId: 627,
              parentId: 0,
              projectId: 60104,
              boxId: 0,
            },
            store: this.$store,
          }).then((res) => {
            this.handleLoading({ isLoading: false });
            // console.log('res', res);
            if (res !== false) {
              // alert(res);
              //console.log('res', res.data.task);
              //res.data.task.i3 = null;
              this.taskModel = res.data.task;

              
            }
          });



        }
      });
    },
  },
};
</script>
<style>
@import "https://res.gosmart.mn/static/df/assets/css/dashforge.css";
.el-dialog__header {
  border-bottom: 1px solid rgba(72, 94, 144, 0.16);
  font-weight: 500;
}
.containerImg {
  display: flex;
  justify-content: center; /* Center horizontally */
  align-items: center; /* Center vertically */
  width: 100%; /* Adjust as needed */
  padding-bottom: 20px;
  /* Adjust as needed */
}
.el-alert__description {
  font-size: 12px !important;
  line-height: 16px !important;
}
.el-alert__title {
  font-size: 12px !important;
  line-height: 14px !important;
  font-weight: 700;
}

.el-form-item__label{
  line-height: 1.2;
}
</style>
